import React from 'react';

const FooterSloganEN = (props) => (
	<svg
		id="Warstwa_1"
		data-name="Warstwa 1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 1244.21 39"
		{...props}
	>
		<defs>
			<style>
				{
					"\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #e31f13;\n      }\n    "
				}
			</style>
		</defs>
		<g>
			<g>
				<polygon
					className="cls-1 white"
					points="9.14 6.13 3.18 6.13 3.18 .93 1.35 .93 1.35 13.27 3.18 13.27 3.18 7.86 9.14 7.86 9.14 13.27 10.97 13.27 10.97 .93 9.14 .93 9.14 6.13"
				/>
				<path
					className="cls-1"
					d="M17.6,13.5c1.78,0,3.12-.83,3.84-2.04l-1.3-.85c-.53.83-1.43,1.34-2.54,1.34-1.62,0-2.61-1.02-2.82-2.63h7.03l.04-.85c.09-2.4-1.53-4.49-4.28-4.49-2.54,0-4.53,1.87-4.53,4.71s1.85,4.81,4.56,4.81ZM17.57,5.48c1.48,0,2.54,1.06,2.57,2.36h-5.32c.28-1.39,1.23-2.36,2.75-2.36Z"
				/>
				<rect
					className="cls-1"
					x={23.61}
					y={0.05}
					width={1.76}
					height={13.22}
				/>
				<path
					className="cls-1"
					d="M37.04,8.74c0-2.71-1.67-4.76-4.16-4.76-1.45,0-2.54.76-2.94,1.85h-.37v-1.62h-1.75v12.76h1.75v-5.32h.35c.42,1.11,1.5,1.85,2.96,1.85,2.45,0,4.16-2.04,4.16-4.76ZM29.5,8.74c0-1.76,1.16-3.15,2.86-3.15s2.89,1.22,2.89,3.15-1.23,3.15-2.85,3.15-2.89-1.15-2.89-3.15Z"
				/>
				<rect className="cls-1" x={38.86} y={0.54} width={1.78} height={2.08}/>
				<rect className="cls-1" x={38.88} y={4.21} width={1.76} height={9.06}/>
				<path
					className="cls-1"
					d="M49.31,7.79v5.48h1.76v-5.99c0-1.73-1.11-3.3-3.21-3.3-1.39,0-2.31.88-2.59,1.85h-.35v-1.62h-1.76v9.06h1.76v-5.29c0-1.34.92-2.33,2.27-2.33,1.18,0,2.12.88,2.12,2.13Z"
				/>
				<path
					className="cls-1"
					d="M57.03,17.2c2.13,0,4.74-.63,4.74-3.07,0-1.59-1.15-2.63-2.94-2.63h-2.61c-.46,0-.88-.19-.88-.65,0-.3.21-.51.39-.58.39.14.83.19,1.25.19,1.89,0,3.54-1,3.54-2.82,0-.83-.51-1.55-1.32-1.74v-.35h2.43v-1.52l-3.4.16c-.41-.14-.83-.21-1.25-.21-2.1,0-3.61,1.29-3.61,3.28,0,.99.39,1.8,1.02,2.33-.37.21-.76.65-.76,1.29,0,.69.44,1.22,1.16,1.38v.35h-.25c-1.22,0-1.97.88-1.97,1.87,0,1.89,1.96,2.73,4.46,2.73ZM56.98,5.44c1.16,0,1.9.79,1.9,1.82,0,1.11-.74,1.87-1.9,1.87s-1.89-.76-1.89-1.87c0-1.02.74-1.82,1.89-1.82ZM55.76,13.02h2.73c.99,0,1.5.49,1.5,1.16,0,1.11-1.34,1.48-2.96,1.48-1.41,0-2.68-.32-2.68-1.46,0-.69.56-1.18,1.41-1.18Z"
				/>
				<path
					className="cls-1"
					d="M69.16,13.27h1.76v-7.53h2.56v-1.53h-2.56v-1.62c0-.71.44-1,.99-1h1.13V.05h-1.34c-1.38,0-2.52.85-2.52,2.56v1.6h-1.82v1.53h1.8v7.53Z"
				/>
				<path
					className="cls-1"
					d="M77.48,6.13h-.37v-1.92h-1.75v9.06h1.76v-4.56c0-1.46.86-2.77,2.7-2.77h.6v-1.89c-1.83,0-2.68,1.2-2.94,2.08Z"
				/>
				<path
					className="cls-1"
					d="M86.13,3.98c-2.77,0-4.78,1.99-4.78,4.76s2.01,4.76,4.78,4.76,4.78-1.97,4.78-4.76-2.06-4.76-4.78-4.76ZM86.13,11.89c-1.71,0-2.98-1.25-2.98-3.15s1.27-3.15,2.98-3.15,2.98,1.3,2.98,3.15-1.27,3.15-2.98,3.15Z"
				/>
				<path
					className="cls-1"
					d="M103.21,3.98c-1.39,0-2.24.86-2.57,1.85h-.39c-.35-1-1.29-1.85-2.78-1.85-1.39,0-2.27.88-2.54,1.85h-.35v-1.62h-1.76v9.06h1.76v-5.29c0-1.36.86-2.33,2.08-2.33s2.06.83,2.06,2.11v5.5h1.76v-5.29c0-1.48.92-2.33,2.1-2.33s2.03.83,2.03,2.13v5.48h1.76v-5.99c0-1.76-1.13-3.3-3.16-3.3Z"
				/>
				<path
					className="cls-1"
					d="M115.8,2.17h-1.73v2.04h-1.62v1.5h1.59v5.11c0,1.71,1.09,2.45,2.47,2.45h1.87v-1.57h-1.64c-.55,0-.93-.26-.93-.97v-5.02h2.7v-1.5h-2.7v-2.04Z"
				/>
				<path
					className="cls-1"
					d="M125.21,3.98c-1.38,0-2.31.83-2.61,1.85h-.35V.05h-1.76v13.22h1.76v-5.29c0-1.34.93-2.33,2.29-2.33,1.18,0,2.15.88,2.15,2.13v5.48h1.76v-5.99c0-1.74-1.15-3.3-3.24-3.3Z"
				/>
				<path
					className="cls-1"
					d="M134.73,3.98c-2.54,0-4.53,1.87-4.53,4.71s1.85,4.81,4.56,4.81c1.78,0,3.12-.83,3.84-2.04l-1.3-.85c-.53.83-1.43,1.34-2.54,1.34-1.62,0-2.61-1.02-2.82-2.63h7.03l.04-.85c.09-2.4-1.53-4.49-4.28-4.49ZM131.98,7.84c.28-1.39,1.23-2.36,2.75-2.36s2.54,1.06,2.57,2.36h-5.32Z"
				/>
				<path
					className="cls-1"
					d="M150.47,3.98c-1.52,0-2.61.83-3.01,1.85h-.35V.05h-1.75v13.22h1.75v-1.62h.37c.39,1.09,1.46,1.85,3,1.85,2.43,0,4.11-2.03,4.11-4.74s-1.71-4.78-4.11-4.78ZM149.89,11.89c-1.69,0-2.86-1.38-2.86-3.14,0-2.01,1.32-3.17,2.89-3.17s2.85,1.29,2.85,3.17-1.23,3.14-2.89,3.14Z"
				/>
				<path
					className="cls-1"
					d="M160.31,3.98c-2.54,0-4.53,1.87-4.53,4.71s1.85,4.81,4.56,4.81c1.78,0,3.12-.83,3.84-2.04l-1.3-.85c-.53.83-1.43,1.34-2.54,1.34-1.62,0-2.61-1.02-2.82-2.63h7.03l.04-.85c.09-2.4-1.53-4.49-4.28-4.49ZM157.56,7.84c.28-1.39,1.23-2.36,2.75-2.36s2.54,1.06,2.57,2.36h-5.32Z"
				/>
				<path
					className="cls-1"
					d="M171.73,11.51h-2.61c-.46,0-.88-.19-.88-.65,0-.3.21-.51.39-.58.39.14.83.19,1.25.19,1.89,0,3.54-1,3.54-2.82,0-.83-.51-1.55-1.32-1.74v-.35h2.43v-1.52l-3.4.16c-.41-.14-.83-.21-1.25-.21-2.1,0-3.61,1.29-3.61,3.28,0,.99.39,1.8,1.02,2.33-.37.21-.76.65-.76,1.29,0,.69.44,1.22,1.16,1.38v.35h-.25c-1.22,0-1.97.88-1.97,1.87,0,1.89,1.96,2.73,4.46,2.73,2.13,0,4.74-.63,4.74-3.07,0-1.59-1.15-2.63-2.94-2.63ZM169.88,5.44c1.16,0,1.9.79,1.9,1.82,0,1.11-.74,1.87-1.9,1.87s-1.89-.76-1.89-1.87c0-1.02.74-1.82,1.89-1.82ZM169.93,15.67c-1.41,0-2.68-.32-2.68-1.46,0-.69.56-1.18,1.41-1.18h2.73c.99,0,1.5.49,1.5,1.16,0,1.11-1.34,1.48-2.96,1.48Z"
				/>
				<rect
					className="cls-1"
					x={176.49}
					y={4.21}
					width={1.76}
					height={9.06}
				/>
				<rect
					className="cls-1"
					x={176.47}
					y={0.54}
					width={1.78}
					height={2.08}
				/>
				<path
					className="cls-1"
					d="M185.48,3.98c-1.39,0-2.31.88-2.59,1.85h-.35v-1.62h-1.76v9.06h1.76v-5.29c0-1.34.92-2.33,2.27-2.33,1.18,0,2.12.88,2.12,2.13v5.48h1.76v-5.99c0-1.73-1.11-3.3-3.21-3.3Z"
				/>
				<path
					className="cls-1"
					d="M195.84,3.98c-1.39,0-2.31.88-2.59,1.85h-.35v-1.62h-1.76v9.06h1.76v-5.29c0-1.34.92-2.33,2.27-2.33,1.18,0,2.12.88,2.12,2.13v5.48h1.76v-5.99c0-1.73-1.11-3.3-3.21-3.3Z"
				/>
				<rect
					className="cls-1"
					x={201.41}
					y={0.54}
					width={1.78}
					height={2.08}
				/>
				<rect
					className="cls-1"
					x={201.43}
					y={4.21}
					width={1.76}
					height={9.06}
				/>
				<path
					className="cls-1"
					d="M210.42,3.98c-1.39,0-2.31.88-2.59,1.85h-.35v-1.62h-1.76v9.06h1.76v-5.29c0-1.34.92-2.33,2.27-2.33,1.18,0,2.12.88,2.12,2.13v5.48h1.76v-5.99c0-1.73-1.11-3.3-3.21-3.3Z"
				/>
				<path
					className="cls-1"
					d="M221.38,11.51h-2.61c-.46,0-.88-.19-.88-.65,0-.3.21-.51.39-.58.39.14.83.19,1.25.19,1.89,0,3.54-1,3.54-2.82,0-.83-.51-1.55-1.32-1.74v-.35h2.43v-1.52l-3.4.16c-.41-.14-.83-.21-1.25-.21-2.1,0-3.61,1.29-3.61,3.28,0,.99.39,1.8,1.02,2.33-.37.21-.76.65-.76,1.29,0,.69.44,1.22,1.16,1.38v.35h-.25c-1.22,0-1.97.88-1.97,1.87,0,1.89,1.96,2.73,4.46,2.73,2.13,0,4.74-.63,4.74-3.07,0-1.59-1.15-2.63-2.94-2.63ZM219.53,5.44c1.16,0,1.9.79,1.9,1.82,0,1.11-.74,1.87-1.9,1.87s-1.89-.76-1.89-1.87c0-1.02.74-1.82,1.89-1.82ZM219.58,15.67c-1.41,0-2.68-.32-2.68-1.46,0-.69.56-1.18,1.41-1.18h2.73c.99,0,1.5.49,1.5,1.16,0,1.11-1.34,1.48-2.96,1.48Z"
				/>
				<path
					className="cls-1"
					d="M226.14,10.89v2.38h.85v.18c0,.78-.21,1.37-1.15,1.64l.39,1.06h.23c1.32-.42,1.87-1.46,1.87-2.7v-2.56h-2.19Z"
				/>
				<path
					className="cls-1"
					d="M4.91,25.93c-2.54,0-4.53,1.87-4.53,4.71s1.85,4.81,4.56,4.81c1.78,0,3.12-.83,3.84-2.04l-1.3-.85c-.53.83-1.43,1.34-2.54,1.34-1.62,0-2.61-1.02-2.82-2.63h7.03l.04-.85c.09-2.4-1.53-4.49-4.28-4.49ZM2.16,29.79c.28-1.39,1.23-2.36,2.75-2.36s2.54,1.06,2.57,2.36H2.16Z"
				/>
				<path
					className="cls-1"
					d="M15.8,25.93c-1.39,0-2.31.88-2.59,1.85h-.35v-1.62h-1.76v9.06h1.76v-5.29c0-1.34.92-2.33,2.27-2.33,1.18,0,2.12.88,2.12,2.13v5.48h1.76v-5.99c0-1.73-1.11-3.3-3.21-3.3Z"
				/>
				<path
					className="cls-1"
					d="M28.23,27.78h-.35c-.37-1.02-1.45-1.85-2.98-1.85-2.4,0-4.14,2.04-4.14,4.78s1.73,4.74,4.14,4.74c1.53,0,2.61-.76,2.96-1.85h.37v1.62h1.75v-13.22h-1.75v5.78ZM25.45,33.84c-1.66,0-2.89-1.22-2.89-3.14s1.23-3.17,2.86-3.17,2.89,1.16,2.89,3.17c0,1.76-1.16,3.14-2.86,3.14Z"
				/>
				<rect className="cls-1" x={32.29} y={22} width={1.76} height={13.22}/>
				<path
					className="cls-1"
					d="M40.32,25.93c-2.54,0-4.53,1.87-4.53,4.71s1.85,4.81,4.56,4.81c1.78,0,3.12-.83,3.84-2.04l-1.3-.85c-.53.83-1.43,1.34-2.54,1.34-1.62,0-2.61-1.02-2.82-2.63h7.03l.04-.85c.09-2.4-1.53-4.49-4.28-4.49ZM37.57,29.79c.28-1.39,1.23-2.36,2.75-2.36s2.54,1.06,2.57,2.36h-5.32Z"
				/>
				<path
					className="cls-1"
					d="M51.06,30.01l-1.53-.33c-.85-.18-1.29-.51-1.29-1.11,0-.63.65-1.15,1.76-1.15s1.87.62,2.03,1.53l1.57-.42c-.35-1.6-1.74-2.61-3.59-2.61-2.15,0-3.45,1.18-3.45,2.64,0,1.64,1.2,2.31,2.5,2.59l1.57.33c.88.19,1.29.56,1.29,1.16,0,.71-.69,1.25-2.03,1.25-1.11,0-2.04-.53-2.29-1.64l-1.6.42c.39,1.64,1.75,2.75,3.84,2.75,2.31,0,3.79-1.11,3.79-2.78,0-1.5-1-2.31-2.55-2.64Z"
				/>
				<path
					className="cls-1"
					d="M60.45,30.01l-1.53-.33c-.85-.18-1.29-.51-1.29-1.11,0-.63.65-1.15,1.76-1.15s1.87.62,2.03,1.53l1.57-.42c-.35-1.6-1.74-2.61-3.59-2.61-2.15,0-3.45,1.18-3.45,2.64,0,1.64,1.2,2.31,2.5,2.59l1.57.33c.88.19,1.29.56,1.29,1.16,0,.71-.69,1.25-2.03,1.25-1.11,0-2.04-.53-2.29-1.64l-1.6.42c.39,1.64,1.75,2.75,3.84,2.75,2.31,0,3.79-1.11,3.79-2.78,0-1.5-1-2.31-2.55-2.64Z"
				/>
				<rect className="cls-1" x={65.16} y={22} width={1.76} height={13.22}/>
				<polygon
					className="cls-1 white"
					points="73.27 33.66 72.9 33.66 70.24 26.16 68.44 26.16 68.44 26.38 71.63 35.21 72.58 35.21 71.26 38.69 71.26 38.92 73.13 38.92 77.85 26.38 77.85 26.16 76.02 26.16 73.27 33.66"
				/>
			</g>
			<polygon
				className="cls-3"
				points="96.04 34.5 96.04 26.15 86.95 26.15 86.95 35.25 95.64 35.25 96.04 35.25 1244.21 35.25 1244.21 34.5 96.04 34.5"
			/>
		</g>
		<rect className="cls-2" y={0.02} width={273.45} height={38.93}/>
		<rect className="cls-2" y={0.02} width={273.45} height={38.93}/>
	</svg>
)
;

export default FooterSloganEN;
